import styled, { css } from "styled-components"

const musicPlayerButtonStyles = css`
  min-height: 65px;

  &:hover {
    text-decoration: none;
  }

  img {
    max-width: 22px;
  }

  span {
    line-height: 1.5;
  }
`

export const AudioPlayerContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  height: 65px;
  max-width: 100%;

  overflow: hidden;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.13);
  border-radius: ${({ theme }) => theme.size.borderRadius};
`

export const AudioPlayerButtons = styled.div<{ withNextPrev: boolean }>`
  height: 100%;
  max-width: ${({ withNextPrev }) => (withNextPrev ? "144px" : "88px")};
  padding: 0 10px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-around;

  color: white;
  font-weight: 400;
  letter-spacing: 2px;
  font-size: ${13 / 16}rem;
  background-color: ${({ theme }) => theme.color.button};
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.font.display};

  transition: all 0.3s ease-in-out;

  ${musicPlayerButtonStyles};
`

export const AudioPlayerButton = styled.button`
  padding: 10px;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;

  svg {
    max-width: unset;
  }

  &:hover {
    svg {
      .arrow-triangle {
        fill: ${({ theme }) => theme.color.hoverPlayerArrow};
        transition: fill 0.3s;
      }
      .play-circle {
        fill: black;
        transition: fill 0.3s;
      }
    }
  }
`

export const TimeLineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0 16px;
`

const textStyles = css`
  min-width: 32px;
  font-size: ${16 / 20}rem;
  color: ${({ theme }) => theme.color.textDisplay};
  padding-bottom: 8px;
`

export const AudioTimer = styled.p`
  ${textStyles}
`

export const SongTitle = styled.p`
  margin-top: 0;
  ${textStyles}
`
